<template>
  <div>
    <div class="flex flex-wrap gap-3 items-end mb-3">
      <div class="flex flex-col min-w-[180px] flex-1">
        <label
          for="mobileSelect"
          class="mb-1 text-sm font-medium text-gray-700"
        >
          Select Mobile to WhatsApp invoice
        </label>
        <select
          id="mobileSelect"
          v-model="selectedMobile"
          class="px-4 py-2 w-full bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="(item, index) in userMobiles"
            :value="item.value"
            :label="item.label + ' : ' + item.value"
            :key="index"
          >
            {{ item.label }} : {{ item.value }}
          </option>
          <option value="">Enter Manually</option>
        </select>
      </div>

      <div class="flex flex-col min-w-[180px] flex-1">
        <label
          for="manualMobile"
          class="mb-1 text-sm font-medium text-gray-700"
        >
          Enter number manually
        </label>
        <input
          id="manualMobile"
          v-model="selectedMobile"
          type="text"
          placeholder="Or enter phone here"
          class="px-4 py-2 w-full border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <button
        type="button"
        @click="handleSendWhatsappSaleQuotationInvoice()"
        class="inline-flex items-center justify-center px-4 py-2 text-white whitespace-nowrap bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <span>Send to Whatsapp</span>
        <span v-if="isWhatsappLoader" class="ml-2">
          <i class="fas fa-spinner fa-spin" />
        </span>
      </button>

      <button
        type="button"
        @click="handlePrint()"
        class="inline-flex items-center justify-center px-4 py-2 text-white whitespace-nowrap bg-gray-600 rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        <i class="mr-2 fas fa-print" />
        <span>Print</span>
      </button>
    </div>
    <div v-if="data && data.user" class="p-3 bg-gray-100">
      <div
        ref="printArea"
        class="max-w-4xl p-4 mx-auto bg-white rounded-lg shadow-md"
      >
        <div class="flex items-center justify-between pb-4 mb-4 border-b">
          <div>
            <h1 class="text-2xl font-bold text-gray-700">Quote</h1>
            <p class="text-sm text-gray-500">{{ "" }}</p>
            <p class="text-sm text-gray-500">
              Date: {{ data.createdAt | convertDate }}
            </p>
          </div>
          <div class="text-right">
            <img
              src="../../assets/images/rajput.png"
              width="350"
              height="50"
              alt=""
            />
            <p class="text-sm text-gray-500">Shop No. 13,14, 15</p>
            <p class="text-sm text-gray-500">
              "P" Building, Lokasangam Vihar,
            </p>
            <p class="text-sm text-gray-500">
              Near D.P. Road, Aundh, Pune-07
            </p>
            <p class="text-sm text-gray-500">Phone: 8237478645/8237478647</p>
            <p class="text-sm text-gray-500">GSTIN: 27AEEPR1809Q1ZY</p>
          </div>
        </div>

        <!-- Recipient Details -->
        <div class="mb-4">
          <h3 class="mb-2 text-lg font-semibold text-gray-700">
            Quotation For:
          </h3>
          <p class="text-sm text-gray-500 capitalize">
            {{ data.user.firstName }} {{ data.user.lastName }}
          </p>
          <p class="text-sm text-gray-500">Phone: {{ data.user.phone }}</p>
        </div>

        <!-- Items Table -->
        <div class="mb-6">
          <table class="w-full text-sm border border-collapse border-gray-200">
            <thead>
              <tr class="bg-gray-100">
                <th class="px-4 py-2 text-left border border-gray-200">
                  Description
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Price
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Qty
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Disc %/₹
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Tax %
                </th>
                <th class="px-4 py-2 text-right border border-gray-200">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.productMeta" :key="index">
                <td class="px-4 py-2 border border-gray-200">
                  {{ item.name }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.price | currency }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.quantity }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.discount }}{{ item.isPercentage ? "%" : "₹" }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{ item.taxRate }}
                </td>
                <td class="px-4 py-2 text-right border border-gray-200">
                  {{
                    (item.price * item.quantity -
                      (item.isPercentage
                        ? (item.price * item.quantity * item.discount) / 100
                        : item.discount) +
                      ((item.price * item.quantity -
                        (item.isPercentage
                          ? (item.price * item.quantity * item.discount) / 100
                          : item.discount)) *
                        item.taxRate) /
                        100)
                      | currency
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-between pt-4 border-t">
          <div>
            <h3 class="text-lg font-semibold text-gray-700">Notes</h3>
            <p class="text-sm text-gray-500">Thank you, visit again!</p>
          </div>
          <div class="text-right">
            <p class="text-sm text-gray-500">
              Total:
              <span class="font-semibold">{{
                data.productMeta.reduce((total, item) => {
                  const itemTotal = item.price * item.quantity;
                  const discount = item.isPercentage
                    ? (itemTotal * item.discount) / 100
                    : item.discount;
                  const discountedPrice = itemTotal - discount;
                  const tax = (discountedPrice * item.taxRate) / 100;
                  return total + discountedPrice + tax;
                }, 0) | currency
              }}</span>
            </p>

            <p class="text-sm text-gray-500">
              Total Tax:
              <span class="font-semibold">{{
                data.productMeta.reduce(
                  (total, item) =>
                    total +
                    ((item.price * item.quantity -
                      (item.isPercentage
                        ? (item.price * item.quantity * item.discount) / 100
                        : item.discount)) *
                      item.taxRate) /
                      100,
                  0
                ) | currency
              }}</span>
            </p>

            <p class="text-lg font-bold text-gray-700">
              Rounded Total:
              {{
                Math.round(
                  data.productMeta.reduce((total, item) => {
                    const itemTotal = item.price * item.quantity;
                    const discount = item.isPercentage
                      ? (itemTotal * item.discount) / 100
                      : item.discount;
                    const discountedPrice = itemTotal - discount;
                    const tax = (discountedPrice * item.taxRate) / 100;
                    return total + discountedPrice + tax;
                  }, 0)
                ) | currency
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { printElementAsA4 } from "@/utils/printA4";

export default {
  name: "SaleQuotationDesign",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      userMobiles: [],
      selectedMobile: null,
      isWhatsappLoader: false
    };
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      })
        .format(amount)
        .replace(".00", "");
    },
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  mounted() {
    this.getUserMobiles();
  },
  methods: {
    resetProperty() {
      this.userMobiles = null; // Reset the property
      this.selectedMobile = null;
    },
    handlePrint() {
      printElementAsA4(this.$refs.printArea, { title: "Sale Quotation" });
    },
    getUserMobiles() {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${this.data.userId}/mobiles`
        )
        .then(response => {
          this.userMobiles = response.data.mobiles;
        })
        .catch(err => {
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    },

    handleSendWhatsappSaleQuotationInvoice() {
      this.isWhatsappLoader = true;
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/send/sale-quotation-invoice/${this.data.userQuotationId}`,
          { phone: this.selectedMobile }
        )
        .then(response => {
          this.isWhatsappLoader = false;
          this.userMobiles = [];
          this.selectedMobile = null;
          this.$notify({
            message: "Invoice sent to whtasapp",
            type: "success",
            title: "Success"
          });
        })
        .catch(err => {
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    }
  }
};
</script>
